import React, { FC, ReactNode } from 'react';
import { Card, Col, Row } from 'reactstrap';
import { OAuthApp } from '../../../../APIClient';
import { useTranslation } from '../../../../translations';

import './Container.scss';

interface OAuthContainerProps {
  readonly app: OAuthApp;
  readonly children: ReactNode;
}

export const OAuthContainer: FC<OAuthContainerProps> = ({ children, app }) => {
  const { ts } = useTranslation();

  return (
    <Row>
      <Col className="margin-center mt-10 oauth" lg={8} md={10} s={12} xl={6}>
        <div className="appicon">
          <img src="/api/logo" style={{ maxWidth: '128px' }} />
        </div>
        <h4 className="text-center">
          {ts('authorize')}: {app.name}
        </h4>
        {app.description && <p className="text-center">{app.description}</p>}
        <Card>{children}</Card>
      </Col>
    </Row>
  );
};
